import type { FadeOverlay } from '../../ui';

export async function withFade(
  overlay: FadeOverlay,
  fadeMs: number,
  holdMs: number,
  midAction: () => Promise<void> | void
): Promise<void> {
  await overlay.fadeTo(1, fadeMs);
  if (holdMs > 0) await wait(holdMs);
  await midAction();
  await overlay.fadeTo(0, fadeMs);
}

function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
